import _ from "lodash";

const COMMISSION_AFFECTING_FIELDS = [
  { path: "product", label: "Product" },
  { path: "productVariations", label: "Product variations" },
  { path: "productCustomOptions", label: "Product custom options" },
  { path: "professionalInvestor", label: "Professional investor" },
  { path: "consultants", label: "Consultants" },
  { path: "signedDate", label: "Signed date" },
  { path: "policyIssueDate", label: "Policy issue date" },
  { path: "insuredAge", label: "Insured age" },
  { path: "forceUncertainPayment", label: "Force uncertain payment" },
  { path: "payment.premium", label: "Premium" },
  { path: "payment.currency", label: "Currency" },
  { path: "payment.payMode", label: "Payment mode" },
  { path: "payment.paymentTerm", label: "Payment term" },
  { path: "payment.paymentTermUntilAge", label: "Payment term until age" },
  { path: "payment.sumInsured", label: "Sum insured" },
  { path: "payment.initialPayment", label: "Initial payment" },
  { path: "payment.initialPaymentCurrency", label: "Initial payment currency" },
];

const normalizeId = (value) => {
  if (value == null) return value;
  if (typeof value === "string") return value;
  if (typeof value === "object" && value._id != null) return String(value._id);
  return value;
};

const normalizeConsultants = (consultants) =>
  (consultants ?? []).map((consultant) => normalizeId(consultant));

const normalizeSnapshotValue = (path, value) => {
  if (path === "consultants") return normalizeConsultants(value);
  if (path === "product") return normalizeId(value);
  if (path === "productVariations" || path === "productCustomOptions") {
    return value ?? null;
  }
  return value ?? null;
};

const pickCommissionAffectingSnapshot = (order = {}) => {
  const snapshot = { _id: order?._id ?? null };
  for (const { path } of COMMISSION_AFFECTING_FIELDS) {
    snapshot[path] = normalizeSnapshotValue(path, _.get(order, path));
  }
  return snapshot;
};

const getCommissionAffectingChanges = (before = {}, after = {}) => {
  const changes = [];
  for (const { path, label } of COMMISSION_AFFECTING_FIELDS) {
    const previousValue = normalizeSnapshotValue(path, _.get(before, path));
    const nextValue = normalizeSnapshotValue(path, _.get(after, path));
    if (!_.isEqual(previousValue, nextValue)) {
      changes.push({ field: path, label });
    }
  }
  return changes;
};

const hasCommissionAffectingChanges = (before = {}, after = {}) =>
  getCommissionAffectingChanges(before, after).length > 0;

export {
  COMMISSION_AFFECTING_FIELDS,
  pickCommissionAffectingSnapshot,
  getCommissionAffectingChanges,
  hasCommissionAffectingChanges,
};
